var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Elements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 117,
    viewBox: "0 0 181 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 117,
    rx: 9,
    fill: "#44A6DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 80,
    height: 105,
    rx: 5,
    fill: "#2F6D90"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 6,
    width: 80,
    height: 105,
    rx: 5,
    fill: "#2F6D90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Elements);
export default __webpack_public_path__ + "static/media/2elements.4f221539833a9ab00518b290611f0b0f.svg";
export { ForwardRef as ReactComponent };